import { useSyncExternalStore } from 'react';

const PHONE_MEDIA_QUERY = '(max-width: 600px)';

function subscribe(onStoreChange: () => void): () => void {
  const mediaQuery = window.matchMedia(PHONE_MEDIA_QUERY);
  mediaQuery.addEventListener('change', onStoreChange);
  return () => mediaQuery.removeEventListener('change', onStoreChange);
}

function getPhoneViewportSnapshot(): boolean {
  return window.matchMedia(PHONE_MEDIA_QUERY).matches;
}

function getPhoneViewportServerSnapshot(): boolean {
  return false;
}

export function usePhoneViewport(): boolean {
  return useSyncExternalStore(
    subscribe,
    getPhoneViewportSnapshot,
    getPhoneViewportServerSnapshot
  );
}
